const parser = new DOMParser()

export function parseDom(html) {
	return typeof html === 'string' ? parser.parseFromString(html, 'text/html') : html
}

export function Dom() {
  return new Promise((resolve) => {
    if (document.readyState == 'loading') {
      document.addEventListener('DOMContentLoaded', resolve)
    } else {
      resolve()
    }
  })
}
